module.exports = __webpack_public_path__ + "media/images/profile/edit-red-3432281888bbed7442aaea93fdb2f065.svg";